import { Observable } from 'rxjs';
import { IGetGateway } from '../../gateways';
import { IStreet, IStreetListRequest, STREETS_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';

export class StreetGateway implements IGetGateway<
  IStreetListRequest,
  IApiResponse<IStreet[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<IStreet[]> =
    new RestCallBuilder<IStreet[]>([]);

  get(request: IStreetListRequest): Observable<IApiResponse<IStreet[]>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.addressValidationUrl}/streets/`,
        { ...request }
      )
      .validate(API_RESPONSE_SCHEMA(STREETS_SCHEMA), 'Street.get')
      .handleMessages()
      .build();
  }
}
